module.exports = __webpack_public_path__ + "static/media/ic_back.79de6bad.svg";